import { accountBadgeEntityName } from '../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { useDataTableUsingUrl } from '@juvare/common-data-table-ui/DataTable/hooks/useDataTable';
import { FiltersBar } from '@juvare/common-data-table-ui/FiltersBar';
import { useAccountFilter } from '@juvare/contact-management/ui/features/accounts';
import { useDefaultAdvancedSearchItems } from '@juvare/contact-management/ui/features/accounts/hooks/useDefaultAdvancedSearchItems';
import { ContactManagementConfigContext } from '@juvare/contact-management/ui/providers';
import { useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import React from 'react';
import { mapAccountBadgeFilter } from '../utils/mapAccountBadgeFilter';
import { useAccountBadgeFilterConfig } from './useAccountBadgeFilterConfig';
import { useAccountBadgeListColumns } from './useAccountBadgeListColumns';
export function useAccountBadgeTable({ badgeId }) {
    var _a;
    const { t } = useBadgingTranslation();
    const { accountsTableCustomization } = React.useContext(ContactManagementConfigContext);
    const defaultAdvancedSearchItems = useDefaultAdvancedSearchItems();
    const advancedSearchItems = (accountsTableCustomization === null || accountsTableCustomization === void 0 ? void 0 : accountsTableCustomization.onGetAdvancedSearchItems)
        ? accountsTableCustomization.onGetAdvancedSearchItems(defaultAdvancedSearchItems)
        : defaultAdvancedSearchItems;
    const filterConfig = useAccountBadgeFilterConfig(advancedSearchItems, accountsTableCustomization === null || accountsTableCustomization === void 0 ? void 0 : accountsTableCustomization.extendFilters);
    const useResolvedAccountFilter = (_a = accountsTableCustomization === null || accountsTableCustomization === void 0 ? void 0 : accountsTableCustomization.overrideUseAccountFilter) !== null && _a !== void 0 ? _a : useAccountFilter;
    const initialFilter = [
        {
            op: '=',
            column: 'badgeId',
            value: badgeId,
        },
    ];
    const params = {
        useDataProvider: ({ filterData }) => {
            const { data: accountFilter } = useResolvedAccountFilter({ advancedSearchItems, filterData });
            const mappedFilters = mapAccountBadgeFilter({ filterData, accountFilter, initialFilter });
            const response = useStorageList(accountBadgeEntityName, { filter: mappedFilters });
            return Object.assign(Object.assign({}, response), { data: response.data
                    ? {
                        rows: response.data.rows,
                        filteredRowCount: response.data.total,
                    }
                    : undefined, reload: () => {
                    void response.mutate();
                } });
        },
        defaultSortColumnKey: 'accountDisplayName',
        rowSelectionEnabled: true,
    };
    const { dataTableProps, filtersBarProps, reload } = useDataTableUsingUrl(params);
    const defaultColumns = useAccountBadgeListColumns({ fetchAccountBadgeList: reload });
    return {
        dataTableProps: Object.assign(Object.assign({}, dataTableProps), { title: t('badges.badgeDetails.accountBadgeTable.title'), columns: defaultColumns, filtersBar: React.createElement(FiltersBar, Object.assign({}, filtersBarProps, { config: filterConfig })) }),
        reload: () => {
            var _a;
            (_a = dataTableProps.onDeselectAllRows) === null || _a === void 0 ? void 0 : _a.call(dataTableProps);
            reload();
        },
    };
}
